module.exports = __webpack_public_path__ + "assets/blocks-icon.399ad5fe.svg";